if (!customElements.get('video-audio')) {
    customElements.define('video-audio', class VideoAudioControls extends HTMLElement {
        constructor() {
            super();
         
            const videoDesktopSound = this.closest('.banner__media-video').querySelector('.js-audio-control-desktop');
            if (videoDesktopSound) videoDesktopSound.addEventListener('click', this.enableSoundDesktop.bind(this));

            const videoMobileSound = this.closest('.banner__media-video').querySelector('.js-audio-control-mobile');
            if (videoMobileSound) videoMobileSound.addEventListener('click', this.enableSoundMobile.bind(this));

        }

        enableSoundDesktop() {
            const sectionID = this.getAttribute('data-section');
            const videoDesktop = this.closest('.banner__media-video').querySelector('#Video-' + sectionID);
            const videoDesktopSound = this.closest('.banner__media-video').querySelector('.js-audio-control-desktop');
            const newVideoDesktop = new Vimeo.Player(videoDesktop);
            if (videoDesktop.className.includes('first-time')) {
                newVideoDesktop.setVolume(0);
                videoDesktop.classList.remove('first-time');
            }
            newVideoDesktop.getVolume().then(function(t) {
                t > 0 ? (newVideoDesktop.setVolume(0), videoDesktopSound.classList.add('mute'), newVideoDesktop.play()) 
                : (newVideoDesktop.setVolume(1), videoDesktopSound.classList.remove('mute'), newVideoDesktop.play())
            })
        }

        enableSoundMobile() {
            const sectionID = this.getAttribute('data-section');
            const videoMobile = this.closest('.banner__media-video').querySelector('#VideoMobile-' + sectionID);
            const videoMobileSound = this.closest('.banner__media-video').querySelector('.js-audio-control-mobile');
            const newVideoMobile = new Vimeo.Player(videoMobile);
            if (videoMobile.className.includes('first-time')) {
                newVideoMobile.setVolume(0);
                videoMobile.classList.remove('first-time');
            }
            newVideoMobile.getVolume().then(function(t) {
                t > 0 ? (newVideoMobile.setVolume(0), videoMobileSound.classList.add('mute'), newVideoMobile.play()) 
                : (newVideoMobile.setVolume(1), videoMobileSound.classList.remove('mute'), newVideoMobile.play())
            })
        }

    });
}